<template>
  <Modal v-model="model" sticky reset-drag-position title="导入" @on-cancel="cancel" footer-hide scrollable :mask="false" draggable class="import_pop agent_import">
    <div class="import_template">
      <div class="font_style_set">上传Excel文件:</div>
      <Upload :action="uploadUrl" :on-success="handleSuccess" :on-error="handleFail" :format="format">
        <Button icon="ios-cloud-upload-outline">文件上传</Button>
      </Upload>
    </div>
    <div class="import_template_record">
      <div class="font_style_set">支持文件上传格式:xls,xlsx,建议使用导出文档,作为上传文件模板</div>
      <div class="downLoad_file"><a href="javascript:void(0)" @click="downLoadFile(downUrl)" >下载Excel导入模板</a></div>
      <a :href="errorUrl" style="display: none" target="_blank" id="downErrorUrl">错误列表</a>
    </div>
  </Modal>
</template>

<script>
  import {customerPublicBtn} from '@/components/js/CustomerPublicBtn.js'
  export default {
    name: "ImportipPop",
    mixins:[customerPublicBtn],
    props: {
      showImportipPop:Boolean,
      iplisttype:String,
    },
    data(){
      return {
        model:false,
        format:['xls','xlsx'],
        uploadUrl:"",
        token:localStorage.getItem("token"),
        downUrl:'chatBlackList/exportChatBlackListTemplate.json',
        errorUrl:'',
      }
    },
    methods:{
      cancel:function(){
        this.$emit("closeImportipPop",false);
      },
      handleSuccess:function (res, file) {
        this.$Modal.info({
          title:'提示',
          content:res.msg
        });
        this.percentage=100;
        let that=this;
        if(file.response.obj && file.response.obj.url){
          that.errorUrl=this.baseURL+"common/downloadFile.json?type=1"+"&addr="+file.response.obj.url;
          setTimeout(function () {
            document.getElementById("downErrorUrl").click();
          },2000);
        }
        setTimeout(function () {
          that.$emit("closeImportipPop",true);
        },1000);
      },
      handleFail:function (error, file) {
        this.$Modal.info({
          title:'失败提示',
          content:file.response.msg
        });
        if(file.response.obj.url){
          let that=this;
          that.errorUrl=this.baseURL+"common/downloadFile.json?type=1"+"&addr="+file.response.obj.url;
          setTimeout(function () {
            document.getElementById("downErrorUrl").click();
          },2000);
        }
      },
      downLoadFile(downUrl){
        let importlisttype;
        if(this.iplisttype=="1"){
             importlisttype="1,2";
        }else if(this.iplisttype=="2"){
             importlisttype="3";
        }
        let param={
            blackType:importlisttype
        }
        this.operateExcelExport(param,downUrl);
      }
    },
    watch:{
      showImportipPop:function () {
        this.model=this.showImportipPop;
		this.uploadUrl=this.baseURL+"common/importChatBlackList.json?file=&type="+this.iplisttype+"&token="+this.token;
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/systemSetup/DialogueConfigure/ImportipPop.vue